<template>
  <div>{{TUITranslateService.t("TUIChat.[自定义消息]")}}</div>
</template>

<script lang="ts" setup>
import {
  TUITranslateService,
} from '../../../../@aidesk/uikit-engine';
</script>
